<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="store/discount/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { Discount } from '@/modules/store/data/discount/create'
	import { DiscountService } from '@/modules/store/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return Discount;
			},

			service()
			{
				return new DiscountService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>